import { applyNonceToElement } from 'core/utils/csp-nonce';
import { environment } from 'environment';

const envScript = {
  production: '//assets.adobedtm.com/acdc00762da2/7084710cd87a/launch-9fdbbc800192.min.js',
  staging: '//assets.adobedtm.com/acdc00762da2/7084710cd87a/launch-e33a960920cf-development.min.js',
};

function appendCookieAdobeScript(scriptSrc: string) {
  const script = document.createElement('script');
  script.src = scriptSrc;
  script.type = 'text/plain';
  script.className = 'optanon-category-C006';
  script.onload = triggerSatellitePageBottomEvent;
  applyNonceToElement(script);
  document.head.append(script);
}

export function appendOneTrustCookieAdobeScript() {
  const env = environment.production ? 'production' : 'staging';
  appendCookieAdobeScript(envScript[env]);
}

function triggerSatellitePageBottomEvent() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  applyNonceToElement(script);
  script.innerHTML = `(function (name,cb) { const interval = 10;  window.setTimeout(function() { if (window[name]) { callback(window[name]); } else { window.setTimeout(arguments.callee, interval); } }, interval); } })('_satellite','whenAvailable');function whenAvailable() { _satellite.pageBottom(); }`;
  document.body.append(script);
}
